import LegalPageLayout from '../components/LegalPageLayout';

const sections = [
  { id: 'article-1', title: 'Article 1 - Éditeur du Site' },
  { id: 'article-2', title: 'Article 2 - Hébergement' },
  { id: 'article-3', title: 'Article 3 - Directeur de Publication' },
  { id: 'article-4', title: 'Article 4 - Propriété Intellectuelle' },
  { id: 'article-5', title: 'Article 5 - Données Personnelles' },
  { id: 'article-6', title: 'Article 6 - Cookies' },
  { id: 'article-7', title: 'Article 7 - Responsabilité' },
  { id: 'article-8', title: 'Article 8 - Liens Hypertextes' },
  { id: 'article-9', title: 'Article 9 - Droit Applicable' },
  { id: 'article-10', title: 'Article 10 - Contact' },
];

export default function Legal() {
  return (
    <LegalPageLayout
      title="Mentions Légales"
      subtitle="Informations légales relatives au site et à l'application LEMO"
      lastUpdate="26 décembre 2025"
      sections={sections}
    >
      <section id="article-1">
        <h2>Article 1 - Éditeur du Site et de l'Application</h2>
        <p>Le site web et l'application mobile LEMO sont édités par :</p>
        <ul>
          <li><strong>Raison sociale</strong> : Petites Natures</li>
          <li><strong>Forme juridique</strong> : [À compléter - ex : SARL, SAS, Auto-entrepreneur]</li>
          <li><strong>Capital social</strong> : [À compléter]</li>
          <li><strong>Siège social</strong> : [Adresse à compléter]</li>
          <li><strong>SIRET</strong> : [À compléter]</li>
          <li><strong>RCS</strong> : [À compléter]</li>
          <li><strong>Numéro de TVA intracommunautaire</strong> : [À compléter]</li>
          <li><strong>Email</strong> : m.duclos@petites-natures.fr</li>
          <li><strong>Téléphone</strong> : 0689283990</li>
        </ul>
      </section>

      <section id="article-2">
        <h2>Article 2 - Hébergement</h2>
        <p>Le site web et l'application LEMO sont hébergés par :</p>
        <ul>
          <li><strong>Nom de l'hébergeur</strong> : Emergent.sh</li>
          <li><strong>Adresse</strong> : [Adresse de l'hébergeur]</li>
          <li><strong>Site web</strong> : <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer">https://emergent.sh</a></li>
        </ul>
      </section>

      <section id="article-3">
        <h2>Article 3 - Directeur de la Publication</h2>
        <p>Le directeur de la publication est :</p>
        <ul>
          <li><strong>Nom</strong> : Matthieu Duclos</li>
          <li><strong>Qualité</strong> : Gérant / Représentant légal</li>
          <li><strong>Contact</strong> : m.duclos@petites-natures.fr</li>
        </ul>
      </section>

      <section id="article-4">
        <h2>Article 4 - Propriété Intellectuelle</h2>
        
        <h3>4.1 - Contenus protégés</h3>
        <p>
          L'ensemble des contenus présents sur le site et l'application LEMO (textes, images, 
          graphismes, logos, icônes, vidéos, logiciels, bases de données, etc.) sont protégés 
          par le droit d'auteur et les droits de propriété intellectuelle.
        </p>

        <h3>4.2 - Marques</h3>
        <p>
          La marque "LEMO" et le logo associé sont des marques déposées. Toute reproduction, 
          imitation ou utilisation, totale ou partielle, de ces marques sans autorisation 
          expresse est interdite.
        </p>

        <h3>4.3 - Reproduction interdite</h3>
        <p>
          Toute reproduction, représentation, modification, publication, transmission, 
          dénaturation, totale ou partielle du site ou de son contenu, par quelque procédé 
          que ce soit, et sur quelque support que ce soit est interdite sans autorisation 
          préalable écrite de Petites Natures.
        </p>

        <h3>4.4 - Contenus utilisateurs</h3>
        <p>
          Les contenus publiés par les utilisateurs (avis, commentaires, photos) restent 
          la propriété de leurs auteurs. En les publiant sur LEMO, ils accordent à Petites 
          Natures une licence d'utilisation non-exclusive et gratuite.
        </p>
      </section>

      <section id="article-5">
        <h2>Article 5 - Données Personnelles et RGPD</h2>
        
        <h3>5.1 - Responsable du traitement</h3>
        <p>
          Petites Natures est responsable du traitement des données personnelles collectées 
          sur le site et l'application LEMO.
        </p>

        <h3>5.2 - Finalités du traitement</h3>
        <p>Les données personnelles sont collectées pour :</p>
        <ul>
          <li>La gestion des comptes utilisateurs</li>
          <li>Le traitement des commandes</li>
          <li>L'envoi de communications commerciales (avec consentement)</li>
          <li>L'amélioration des services</li>
        </ul>

        <h3>5.3 - Droits des utilisateurs</h3>
        <p>
          Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez 
          des droits d'accès, de rectification, d'effacement, de limitation, de portabilité et 
          d'opposition concernant vos données personnelles.
        </p>
        <p>
          Pour exercer ces droits, contactez-nous à : <strong>m.duclos@petites-natures.fr</strong>
        </p>

        <h3>5.4 - Politique de confidentialité</h3>
        <p>
          Pour plus d'informations sur le traitement de vos données personnelles, consultez 
          notre <a href="/politique-de-confidentialite">Politique de Confidentialité</a>.
        </p>
      </section>

      <section id="article-6">
        <h2>Article 6 - Cookies</h2>
        
        <h3>6.1 - Utilisation des cookies</h3>
        <p>Le site et l'application LEMO utilisent des cookies pour :</p>
        <ul>
          <li>Assurer le bon fonctionnement de la plateforme (cookies techniques)</li>
          <li>Mémoriser vos préférences (cookies de personnalisation)</li>
          <li>Analyser la fréquentation et l'utilisation (cookies analytiques)</li>
        </ul>

        <h3>6.2 - Gestion des cookies</h3>
        <p>
          Vous pouvez à tout moment gérer vos préférences en matière de cookies via les 
          paramètres de votre navigateur ou les paramètres de l'application.
        </p>

        <h3>6.3 - Cookies tiers</h3>
        <p>Nous utilisons les services de partenaires qui peuvent déposer des cookies :</p>
        <ul>
          <li><strong>Stripe</strong> : pour les paiements sécurisés</li>
          <li><strong>Google Maps</strong> : pour les services de géolocalisation</li>
        </ul>
      </section>

      <section id="article-7">
        <h2>Article 7 - Responsabilité</h2>
        
        <h3>7.1 - Contenu du site</h3>
        <p>
          Petites Natures s'efforce d'assurer l'exactitude et la mise à jour des informations 
          diffusées sur le site, mais ne peut garantir l'exactitude, la précision ou l'exhaustivité 
          des informations mises à disposition.
        </p>

        <h3>7.2 - Disponibilité du service</h3>
        <p>
          Petites Natures ne peut garantir une disponibilité permanente du site et de l'application. 
          Des interruptions peuvent survenir pour maintenance, mise à jour ou en cas de force majeure.
        </p>

        <h3>7.3 - Limitation de responsabilité</h3>
        <p>
          Petites Natures décline toute responsabilité en cas de dommages directs ou indirects 
          causés à l'utilisateur ou à un tiers du fait de l'utilisation du site ou de l'application.
        </p>
      </section>

      <section id="article-8">
        <h2>Article 8 - Liens Hypertextes</h2>
        
        <h3>8.1 - Liens sortants</h3>
        <p>
          Le site et l'application peuvent contenir des liens vers des sites tiers 
          (restaurants partenaires, Google Maps, etc.). Petites Natures n'exerce aucun 
          contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
        </p>

        <h3>8.2 - Liens entrants</h3>
        <p>
          La création de liens vers le site LEMO est autorisée sans demande préalable, 
          à condition que ces liens ne portent pas atteinte à l'image de LEMO ou de 
          Petites Natures.
        </p>
      </section>

      <section id="article-9">
        <h2>Article 9 - Droit Applicable et Juridiction</h2>
        <p>
          Les présentes mentions légales sont régies par le droit français.
        </p>
        <p>
          En cas de litige, et après tentative de résolution amiable, les tribunaux français 
          seront seuls compétents, et plus particulièrement le tribunal de <strong>Nanterre (92)</strong>.
        </p>
      </section>

      <section id="article-10">
        <h2>Article 10 - Contact</h2>
        <p>Pour toute question concernant ces mentions légales, vous pouvez nous contacter :</p>
        <ul>
          <li><strong>Email</strong> : m.duclos@petites-natures.fr</li>
          <li><strong>Téléphone</strong> : 0689283990</li>
          <li><strong>Adresse postale</strong> : [Adresse à compléter]</li>
        </ul>
        <p>
          Nous nous engageons à répondre à toute demande dans un délai de <strong>30 jours</strong>.
        </p>
      </section>
    </LegalPageLayout>
  );
}
